import * as React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { Provider } from "react-redux";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { ApolloProvider } from "@apollo/client";

import theme from "../../src/theme";
import store from "../../src/redux/store";
import { client } from "../../src/client.js";

export default function TopLayout(props) {
  return (
    <React.Fragment>
      <Helmet>
        <meta name="viewport" content="initial-scale=1, width=device-width" />
      </Helmet>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <ApolloProvider client={client}>
            {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
            <CssBaseline />
            {props.children}
          </ApolloProvider>
        </ThemeProvider>
      </Provider>
    </React.Fragment>
  );
}

TopLayout.propTypes = {
  children: PropTypes.node,
};
